import { gql } from "@apollo/client";

export const UpdateEmpLoginStatus = gql`
  mutation UpdateEmpLoginStatus(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $empIds: [ID!]!
    $selectAll: Boolean!
    $loginStatus: Boolean!
  ) {
    UpdateEmpLoginStatus(
      token: $token
      customerID: $customerID
      user_details: $user_details
      empIds: $empIds
      selectAll: $selectAll
      loginStatus: $loginStatus
    )
  }
`;
